var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "http://www.toriyasaimiso.jp/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo.svg"),
      "alt": "株式会社まつや"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "tab",
    attrs: {
      "href": "http://www.toriyasaimiso.jp/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/btn_header.svg"),
      "alt": "とり野菜みそオフィシャルサイト"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d9ab25c","hasScoped":true,"transformToRequire":{"video":"src","source":"srcset","img":["src","srcset"],"image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlobalHeader.vue
// module id = 39
// module chunks = 0